import { ALIcons } from '@af-lib/vue-ui';
import { type IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
/* BRANDS */
import {
  /* A */
  /* B */
  faBehance as fabBehance,
  faBitbucket as fabBitbucket,
  faBloggerB as fabBloggerB,
  /* C */
  /* D */
  faDribbble as fabDribbble,
  /* E */
  /* F */
  faFacebookF as fabFacebookF,
  faFigma as fabFigma,
  /* G */
  faGithub as fabGithub,
  faGitlab as fabGitlab,
  faGoogleScholar as fabGoogleScholar,
  /* H */
  /* I */
  faInstagram as fabInstagram,
  /* J */
  /* K */
  faKaggle as fabKaggle,
  /* L */
  faLinkedinIn as fabLinkedinIn,
  /* M */
  faMedium as fabMedium,
  /* N */
  faNotion as fabNotion,
  /* O */
  /* P */
  /* Q */
  /* R */
  faResearchgate as fabResearchgate,
  /* S */
  faStackOverflow as fabStackOverflow,
  /* T */
  faTiktok as fabTiktok,
  faTwitter as fabTwitter,
  /* U */
  /* V */
  faVimeoV as fabVimeoV,
  /* W */
  /* X */
  /* Y */
  faYoutube as fabYoutube
  /* Z */
} from '@fortawesome/free-brands-svg-icons';
/* LIGHT */
import {
  /* B */
  faBoltLightning as falBoltLightning,
  /* E */
  faEnvelope as falEnvelope,
  /* L */
  faLink as falLink,
  /* M */
  faMapPin as falMapPin,
  /* P */
  faPhone as falPhone,
  /* S */
  faSparkle as falSparkle,
  /* T */
  faTag as falTag,
  /* U */
  faUpload as falUpload
} from '@fortawesome/pro-light-svg-icons';
/* REGULAR */
import {
  /* A */
  /* B */
  faBox as farBox,
  faBuilding as farBuilding,
  /* C */
  faCircle as farCircle,
  faCircleDot as farCircleDot,
  faCircleQuestion,
  faClock as farClock,
  faCrown as farCrown,
  /* D */
  faDoorClosed as farDoorClosed,
  /* E */
  /* F */
  /* G */
  faGift as farGift,
  faGripLines as farGripLines,
  /* H */
  faHand as farHand,
  /* I */
  /* J */
  /* K */
  faKey as farKey,
  /* L */
  faListTree as farListTree,
  /* M */
  faMartiniGlassCitrus as farMartiniGlassCitrus,
  faMedal as farMedal,
  /* N */
  /* O */
  /* P */
  /* Q */
  /* R */
  faRoute as farRoute,
  /* S */
  faSliders as farSliders,
  faSquareV as farSquareV,
  faStopwatch as farStopwatch,
  /* T */
  faThumbsDown as farThumbsDown,
  faThumbsUp as farThumbsUp,
  /* U */
  /* V */
  /* W */
  faWaveformLines as farWaveformLines
  /* X */
  /* Y */
  /* Z */
} from '@fortawesome/pro-regular-svg-icons';
/* SOLID */
import {
  /* A */
  faAddressCard as fasAddressCard,
  faAngleDown as fasAngleDown,
  faArrowDownArrowUp as fasArrowDownArrowUp,
  faArrowLeft as fasArrowLeft,
  faArrowRight as fasArrowRight,
  faArrowRightArrowLeft as fasArrowRightArrowLeft,
  faArrowRotateLeft as fasArrowRotateLeft,
  faArrowRotateRight as fasArrowRotateRight,
  faArrowsUpDownLeftRight as fasArrowsUpDownLeftRight,
  faArrowUp as fasArrowUp,
  faArrowUpRight as fasArrowUpRight,
  faArrowUpRightFromSquare as fasArrowUpRightFromSquare,
  faBadgeCheck as fasBadgeCheck,
  /* B */
  faBars as fasBars,
  faBell as fasBell,
  faBellOn as fasBellOn,
  faBolt as fasBolt,
  faBoltLightning as fasBoltLightning,
  faBookmark as fasBookmark,
  faBooks as fasBooks,
  faBriefcase as fasBriefcase,
  faBriefcaseClock as fasBriefcaseClock,
  faBuildingShield as fasBuildingShield,
  faBullhorn as fasBullhorn,
  faBullseyeArrow as fasBullseyeArrow,
  faBusinessTime as fasBusinessTime,
  /* C */
  faCaretRight as fasCaretRight,
  faChartBar as fasChartBar,
  faChartNetwork as fasChartNetwork,
  faCheck as fasCheck,
  faCheckCircle as fasCheckCircle,
  faChevronDoubleLeft as fasChevronDoubleLeft,
  faChevronDoubleRight as fasChevronDoubleRight,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faChevronUp as fasChevronUp,
  faCircle as fasCircle,
  faCircleCheck as fasCircleCheck,
  faCircleChevronLeft as fasCircleChevronLeft,
  faCircleChevronRight as fasCircleChevronRight,
  faCircleExclamation as fasCircleExclamation,
  faCircleInfo as fasCircleInfo,
  faCircleQuestion as fasCircleQuestion,
  faCircleXmark as fasCircleXmark,
  faClipboard as fasClipboard,
  faClipboardList as fasClipboardList,
  faClipboardListCheck as fasClipboardListCheck,
  faClockRotateLeft as fasClockRotateLeft,
  faClone as fasClone,
  faClose as fasClose,
  faCloudUpload as fasCloudUpload,
  faCode as fasCode,
  faCommentDots as fasCommentDots,
  faCommentPlus as fasCommentPlus,
  faCopy as fasCopy,
  faDownload as fasDownload,
  /* D */
  faDownToLine as fasDownToLine,
  /* E */
  faEarthAfrica as fasEarthAfrica,
  faEllipsis as fasEllipsis,
  faEllipsisVertical as fasEllipsisVertical,
  faEnvelope as fasEnvelope,
  faExclamation as fasExclamation,
  faExclamationCircle as fasExcamationCircle,
  faExclamationTriangle as fasExclamationTriangle,
  faEye as fasEye,
  faEyeSlash as fasEyeSlash,
  /* F */
  faFaceSmile as fasFaceSmile,
  faFileExcel as fasFileExcel,
  faFilePdf as fasFilePdf,
  faFilter as fasFilter,
  faFire as fasFire,
  /* G */
  faGear as fasGear,
  faGlobe as fasGlobe,
  faGraduationCap as fasGraduationCap,
  faGift as fasGift,
  faGrid2 as fasGrid2,
  faGripLines as fasGripLines,
  /* H */
  faHandHoldingHeart as fasHandHoldingHeart,
  faHandshake as fasHandshake,
  faHandshakeSlash as fasHandshakeSlash,
  faHeadset as fasHeadset,
  /* I */
  faIdCardAlt as fasIdCardAlt,
  faInfoCircle as fasInfoCircle,
  /* J */
  /* K */
  /* L */
  faLayerGroup as fasLayerGroup,
  faLightbulb as fasLightbulb,
  faLink as fasLink,
  faListCheck as fasListCheck,
  faLocationDot as fasLocationDot,
  faLock as fasLock,
  /* M */
  faMapMarkerAlt as fasMapMarkerAlt,
  faMicrophone as fasMicrophone,
  faMinus as fasMinus,
  /* N */
  /* O */
  /* P */
  faPaperPlane as fasPaperPlane,
  faPen as fasPen,
  faPeopleGroup as fasPeopleGroup,
  faPhone as fasPhone,
  faPlus as fasPlus,
  /* Q */
  faQrcode as fasQrcode,
  faRectangleHistory as fasRectangleHistory,
  /* R */
  faRectanglePro as fasRectanglePro,
  faRotateLeft as fasRotateLeft,
  faRotateRight as fasRotateRight,
  faSearch as fasSearch,
  /* S */
  faSeedling as fasSeedling,
  faShare as fasShare,
  faShareNodes as fasShareNodes,
  faSlidersSimple as fasSlidersSimple,
  faSquareCheck as fasSquareCheck,
  faStar as fasStar,
  faStars as fasStars,
  faStepBackward as fasStepBackward,
  faStepForward as fasStepForward,
  faSync as fasSync,
  /* T */
  faTag as fasTag,
  faTags as fasTags,
  faThumbsDown as fasThumbsDown,
  faThumbsUp as fasThumbsUp,
  faTimesCircle as fasTimesCircle,
  faTrash as fasTrash,
  faUniversalAccess as fasUniversalAccess,
  /* U */
  faUser as fasUser,
  faUserFriends as fasUserFriends,
  faUserMagnifyingGlass as fasUserMagnifyingGlass,
  faUserPlus as fasUserPlus,
  faUsers as fasUsers,
  faUserSlash as fasUserSlash,
  faUserTag as fasUserTag,
  faUserTie as fasUserTie,
  faWandMagicSparkles as fasWandMagicSparkles,
  /* V */
  /* W */
  faWaveformLines as fasWaveformLines,
  /* X */
  faX as fasX,
  faXmark as fasXmark,
  faXmarkLarge as fasXmarkLarge,
  faXmarkToSlot as fasXmarkToSlot
  /* Y */
  /* Z */
} from '@fortawesome/pro-solid-svg-icons';
/* THIN */
import {
  /* A */
  faAnalytics as fatAnalytics,
  faArrowLeft as fatArrowLeft,
  faArrowsRotate as fatArrowsRotate,
  faArrowUp as fatArrowUp,
  faArrowUpArrowDown as fatArrowUpArrowDown,
  faAsterisk as fatAsterisk,
  faAt as fatAt,
  faAward as fatAward,
  /* B */
  faBagShopping as fatBagShopping,
  faBell as fatBell,
  faBellOn as fatBellOn,
  faBolt as fatBolt,
  faBox as fatBox,
  faBookmark as fatBookmark,
  faBrainCircuit as fatBrainCircuit,
  faBriefcase as fatBriefcase,
  faBuilding as fatBuilding,
  faBullhorn as fatBullhorn,
  faBullseyeArrow as fatBullseyeArrow,
  /* C */
  faCakeCandles as fatCakeCandles,
  faCalendarClock as fatCalendarClock,
  faChartBar as fatChartBar,
  faChartColumn as fatChartColumn,
  faChartNetwork as fatChartNetwork,
  faCheck as fatCheck,
  faCheckCircle as fatCheckCircle,
  faChevronDown as fatChevronDown,
  faChevronUp as fatChevronUp,
  faCircle as fatCircle,
  faCircleArrowRight as fatCircleArrowRight,
  faCircleExclamation as fatCircleExclamation,
  faCircleHeart as fatCircleHeart,
  faCircleInfo as fatCircleInfo,
  faCircleQuestion as fatCircleQuestion,
  faCircleXmark as fatCircleXmark,
  faClipboardList as fatClipboardList,
  faClock as fatClock,
  faClose as fatClose,
  faCloudSun as fatCloudSun,
  faCog as fatCog,
  faCoin as fatCoin,
  faCoins as fatCoins,
  faComment as fatComment,
  faCommentDots as fatCommentDots,
  faCommentPlus as fatCommentPlus,
  faComments as fatComments,
  faComputerMouseScrollwheel as fatComputerMouseScrollwheel,
  faCopy as fatCopy,
  faCrown as fatCrown,
  faCrosshairs as fatCrosshairs,
  /* D */
  faDoorClosed as fatDoorClosed,
  faDumbbell as fatDumbbell,
  /* E */
  faEnvelope as fatEnvelope,
  faExclamationTriangle as fatExclamationTriangle,
  faEyeSlash as fatEyeSlash,
  /* F */
  faFileLines as fatFileLines,
  faFilePdf as fatFilePdf,
  faFingerprint as fatFingerprint,
  faFlagCheckered as fatFlagCheckered,
  faFlagPennant as fatFlagPennant,
  /* G */
  faGem as fatGem,
  faGift as fatGift,
  faGlobe as fatGlobe,
  faGraduationCap as fatGraduationCap,
  /* H */
  faHand as fatHand,
  faHandBackPointUp as fatHandBackPointUp,
  faHandHeart as fatHandHeart,
  faHandHoldingHeart as fatHandHoldingHeart,
  faHandPointUp as fatHandPointUp,
  faHandshake as fatHandshake,
  faHandsHoldingHeart as fatHandsHoldingHeart,
  faHeadSide as fatHeadSide,
  faHeart as fatHeart,
  faHourglass as fatHourglass,
  faHouseLaptop as fatHouseLaptop,
  /* I */
  faIndustry as fatIndustry,
  faInfoCircle as fatInfoCircle,
  /* J */
  /* K */
  faKey as fatKey,
  /* L */
  faLaptop as fatLaptop,
  faLayerGroup as fatLayerGroup,
  faLayerPlus as fatLayerPlus,
  faLightbulb as fatLightbulb,
  faLightbulbGear as fatLightbulbGear,
  faLink as fatLink,
  faListCheck as fatListCheck,
  faLocationDot as fatLocationDot,
  /* M */
  faMagnet as fatMagnet,
  faMapPin as fatMapPin,
  faMartiniGlassCitrus as fatMartiniGlassCitrus,
  faMedal as fatMedal,
  faMemoCircleInfo as fatMemoCircleInfo,
  faMessage as fatMessage,
  faMicrophone as fatMicrophone,
  /* N */
  /* O */
  /* P */
  faPaperPlane as fatPaperPlane,
  faPartyHorn as fatPartyHorn,
  faPenPaintbrush as fatPenPaintbrush,
  faPeopleGroup as fatPeopleGroup,
  faPhone as fatPhone,
  faPhoneLaptop as fatPhoneLaptop,
  faPlus as fatPlus,
  faPodiumStar as fatPodiumStar,
  faPuzzlePiece as fatPuzzlePiece,
  /* Q */
  faQuestionCircle as fatQuestionCircle,
  /* R */
  faRectangleHistory as fatRectangleHistory,
  faRocket as fatRocket,
  faRocketLaunch as fatRocketLaunch,
  faRotateRight as fatRotateRight,
  faRoute as fatRoute,
  faRulerTriangle as fatRulerTriangle,
  /* S */
  faSackDollar as fatSackSollar,
  faScaleBalanced as fatScaleBalanced,
  faSearch as fatSearch,
  faShare as fatShare,
  faShareNodes as fatShareNodes,
  faShieldCheck as fatShieldCheck,
  faShuffle as fatShuffle,
  faSignOut as fatSignOut,
  faSitemap as fatSitemap,
  faSmile as fatSmile,
  faSparkle as fatSparkle,
  faSparkles as fatSparkles,
  faSquare as fatSquare,
  faSquareV as fatSquareV,
  faStar as fatStar,
  faStars as fatStars,
  faStopwatch as fatStopwatch,
  /* T */
  faTag as fatTag,
  faTags as fatTags,
  faTelescope as fatTelescope,
  faThumbsUp as fatThumbsUp,
  faTimer as fatTimer,
  faTools as fatTools,
  faTrash as fatTrash,
  faTrophy as fatTrophy,
  faTrophyStar as fatTrophyStar,
  /* U */
  faUpDownLeftRight as fatUpDownLeftRight,
  faUser as fatUser,
  faUserCircle as fatUserCircle,
  faUserMagnifyingGlass as fatUserMagnifyingGlass,
  faUserPlus as fatUserPlus,
  faUsers as fatUsers,
  faUserShield as fatUserShield,
  faUserSlash as fatUserSlash,
  faUserTag as fatUserTag,
  faUserTie as fatUserTie,
  faWandMagicSparkles as fatWandMagicSparkles,
  /* V */
  /* W */
  faWaveformLines as fatWaveformLines,
  faWallet as fatWallet,
  /* X */
  faX as fatX,
  faXmark as fatXmark,
  faXmarkLarge as fatXmarkLarge,
  faXmarkToSlot as fatXmarkToSlot
  /* Y */
  /* Z */
} from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { App } from 'vue';

export default function (app: App) {
  /* LIGHT */
  library.add(
    /* B */
    falBoltLightning,
    /* E */
    falEnvelope,
    /* L */
    falLink,
    /* M */
    falMapPin,
    /* P */
    falPhone,
    /* S */
    falSparkle,
    /* T */
    falTag,
    /* U */
    falUpload
  );

  /* REGULAR */
  library.add(
    /* A */
    /* B */
    farBox,
    farBuilding,
    /* C */
    farCircle,
    farCircleDot,
    farClock,
    farCrown,
    /* D */
    farDoorClosed,
    /* E */
    /* F */
    /* G */
    farGift,
    farGripLines,
    /* H */
    farHand,
    /* I */
    /* J */
    /* K */
    farKey,
    /* L */
    farListTree,
    /* M */
    farMartiniGlassCitrus,
    farMedal,
    /* N */
    /* O */
    /* P */
    /* Q */
    /* R */
    farRoute,
    /* S */
    farSliders,
    farSquareV,
    farStopwatch,
    /* T */
    farThumbsDown,
    farThumbsUp,
    /* U */
    /* V */
    /* W */
    farWaveformLines
    /* X */
    /* Y */
    /* Z */
  );

  /* SOLID */
  library.add(
    /* A */
    fasAddressCard,
    fasArrowLeft,
    fasArrowRightArrowLeft,
    fasArrowDownArrowUp,
    fasAngleDown,
    fasArrowRight,
    fasArrowRotateLeft,
    fasArrowRotateRight,
    fasArrowLeft,
    fasArrowsUpDownLeftRight,
    fasArrowUp,
    fasArrowUpRight,
    fasArrowUpRightFromSquare,
    /* B */
    fasBars,
    fasBadgeCheck,
    fasBell,
    fasBellOn,
    fasBolt,
    fasBoltLightning,
    fasBooks,
    fasBookmark,
    fasBriefcase,
    fasBriefcaseClock,
    fasBuildingShield,
    fasBullhorn,
    fasBullseyeArrow,
    fasBusinessTime,
    /* C */
    fasCaretRight,
    fasChartNetwork,
    fasCheck,
    fasCheckCircle,
    fasChevronDoubleLeft,
    fasChevronDoubleRight,
    fasChevronDown,
    fasChevronLeft,
    fasChevronRight,
    fasCircle,
    fasChartBar,
    fasChevronUp,
    fasCircleCheck,
    fasCircleChevronLeft,
    fasCircleChevronRight,
    fasCircleExclamation,
    fasCircleInfo,
    fasCircleQuestion,
    fasCircleXmark,
    fasClipboardList,
    fasClipboard,
    fasClipboardListCheck,
    fasClockRotateLeft,
    fasClone,
    fasCloudUpload,
    fasClose,
    fasCode,
    fasCommentDots,
    fasCommentPlus,
    fasCopy,
    fasInfoCircle,
    /* D */
    fasDownToLine,
    fasDownload,
    /* E */
    fasEarthAfrica,
    fasEllipsis,
    fasEllipsisVertical,
    fasEnvelope,
    fasEye,
    fasEyeSlash,
    fasExclamation,
    fasExcamationCircle,
    fasExclamationTriangle,
    /* F */
    fasCommentDots,
    fasFaceSmile,
    fasFilter,
    fasFire,
    fasFileExcel,
    fasFilePdf,
    /* G */
    fasGear,
    fasGlobe,
    fasGraduationCap,
    fasGift,
    fasGrid2,
    fasGear,
    fasGripLines,
    /* H */
    fasHandHoldingHeart,
    fasHandshake,
    fasHandshakeSlash,
    fasHeadset,
    /* I */
    fasIdCardAlt,
    /* J */
    /* K */
    /* L */
    fasLayerGroup,
    fasLightbulb,
    fasLink,
    fasListCheck,
    fasLocationDot,
    fasLock,
    /* M */
    fasMapMarkerAlt,
    fasMicrophone,
    fasMinus,
    /* N */
    /* O */
    /* P */
    fasPaperPlane,
    fasPen,
    fasPeopleGroup,
    fasPhone,
    fasPlus,
    /* Q */
    fasQrcode,
    /* R */
    fasRectanglePro,
    fasRotateRight,
    fasRotateLeft,
    fasRectangleHistory,
    /* S */
    fasSeedling,
    fasSearch,
    fasShare,
    fasShareNodes,
    fasSquareCheck,
    fasSlidersSimple,
    fasStar,
    fasStars,
    fasStepBackward,
    fasStepForward,
    fasSync,
    /* T */
    fasTag,
    fasTags,
    fasThumbsDown,
    fasThumbsUp,
    fasTimesCircle,
    fasTrash,
    /* U */
    fasUser,
    fasUserFriends,
    fasUserMagnifyingGlass,
    fasUsers,
    fasUserSlash,
    fasUserPlus,
    fasUserTag,
    fasUserTie,
    fasUniversalAccess,
    /* V */
    /* W */
    fasWaveformLines,
    fasWandMagicSparkles,
    /* X */
    fasX,
    fasXmark,
    fasXmarkLarge,
    fasXmarkToSlot
    /* Y */
    /* Z */
  );

  /* THIN */
  // need 'as IconDefinition', otherwise typescript will peter un gros boulard
  // https://github.com/FortAwesome/angular-fontawesome/issues/125
  library.add(
    /* A */
    fatAnalytics as IconDefinition,
    fatArrowLeft as IconDefinition,
    fatArrowsRotate as IconDefinition,
    fatArrowUpArrowDown as IconDefinition,
    fatArrowUp as IconDefinition,
    fatAsterisk as IconDefinition,
    fatAt as IconDefinition,
    fatAward as IconDefinition,
    /* B */
    fatBagShopping as IconDefinition,
    fatBell as IconDefinition,
    fatBellOn as IconDefinition,
    fatBolt as IconDefinition,
    fatBookmark as IconDefinition,
    fatBox as IconDefinition,
    fatBrainCircuit as IconDefinition,
    fatBriefcase as IconDefinition,
    fatBuilding as IconDefinition,
    fatBullhorn as IconDefinition,
    fatBullseyeArrow as IconDefinition,
    fasBusinessTime as IconDefinition,
    /* C */
    fatCakeCandles as IconDefinition,
    fatCalendarClock as IconDefinition,
    fatChartColumn as IconDefinition,
    fatChartBar as IconDefinition,
    fatChartNetwork as IconDefinition,
    fatCheck as IconDefinition,
    fatCheckCircle as IconDefinition,
    fatChevronDown as IconDefinition,
    fatChevronUp as IconDefinition,
    fatCircle as IconDefinition,
    fatCircleArrowRight as IconDefinition,
    fatCircleExclamation as IconDefinition,
    fatCircleQuestion as IconDefinition,
    fatCircleHeart as IconDefinition,
    fatCircleInfo as IconDefinition,
    faCircleQuestion as IconDefinition,
    fatCircleXmark as IconDefinition,
    fatClipboardList as IconDefinition,
    fatClock as IconDefinition,
    fatClose as IconDefinition,
    fatCloudSun as IconDefinition,
    fatCog as IconDefinition,
    fatCoin as IconDefinition,
    fatCoins as IconDefinition,
    fatComment as IconDefinition,
    fatCommentPlus as IconDefinition,
    fatComments as IconDefinition,
    fatComputerMouseScrollwheel as IconDefinition,
    fatCommentDots as IconDefinition,
    fatCopy as IconDefinition,
    fatCrown as IconDefinition,
    fatCrosshairs as IconDefinition,
    /* D */
    fatDoorClosed as IconDefinition,
    fatDumbbell as IconDefinition,
    /* E */
    fatEnvelope as IconDefinition,
    fatExclamationTriangle as IconDefinition,
    fatEyeSlash as IconDefinition,
    /* F */
    fatFileLines as IconDefinition,
    fatFilePdf as IconDefinition,
    fatFlagCheckered as IconDefinition,
    fatFlagPennant as IconDefinition,
    fatFingerprint as IconDefinition,
    /* G */
    fatGem as IconDefinition,
    fatGift as IconDefinition,
    fatGlobe as IconDefinition,
    fatGraduationCap as IconDefinition,
    /* H */
    fatHand as IconDefinition,
    fatHandHeart as IconDefinition,
    fatHandHoldingHeart as IconDefinition,
    fatHandBackPointUp as IconDefinition,
    fatHandsHoldingHeart as IconDefinition,
    fatHandPointUp as IconDefinition,
    fatHandshake as IconDefinition,
    fatHeadSide as IconDefinition,
    fatHeart as IconDefinition,
    fatHourglass as IconDefinition,
    fatHouseLaptop as IconDefinition,
    /* I */
    fatIndustry as IconDefinition,
    fatInfoCircle as IconDefinition,
    /* J */
    /* K */
    fatKey as IconDefinition,
    /* L */
    fatLaptop as IconDefinition,
    fatLayerPlus as IconDefinition,
    fatLayerGroup as IconDefinition,
    fatLightbulb as IconDefinition,
    fatLightbulbGear as IconDefinition,
    fatLink as IconDefinition,
    fatListCheck as IconDefinition,
    fatLocationDot as IconDefinition,
    /* M */
    fatMagnet as IconDefinition,
    fatMapPin as IconDefinition,
    fatMartiniGlassCitrus as IconDefinition,
    fatMedal as IconDefinition,
    fatMemoCircleInfo as IconDefinition,
    fatMessage as IconDefinition,
    fatMicrophone as IconDefinition,
    /* N */
    /* O */
    /* P */
    fatPaperPlane as IconDefinition,
    fatPartyHorn as IconDefinition,
    fatPenPaintbrush as IconDefinition,
    fatPeopleGroup as IconDefinition,
    fatPhone as IconDefinition,
    fatPhoneLaptop as IconDefinition,
    fatPlus as IconDefinition,
    fatPodiumStar as IconDefinition,
    fatPuzzlePiece as IconDefinition,
    /* Q */
    fatQuestionCircle as IconDefinition,
    /* R */
    fatRectangleHistory as IconDefinition,
    fatRocket as IconDefinition,
    fatRocketLaunch as IconDefinition,
    fatRotateRight as IconDefinition,
    fatRoute as IconDefinition,
    fatRulerTriangle as IconDefinition,
    /* S */
    fatSackSollar as IconDefinition,
    fatScaleBalanced as IconDefinition,
    fatSearch as IconDefinition,
    fatShare as IconDefinition,
    fatShareNodes as IconDefinition,
    fatShieldCheck as IconDefinition,
    fatSignOut as IconDefinition,
    fatSitemap as IconDefinition,
    fatShuffle as IconDefinition,
    fatSmile as IconDefinition,
    fatCommentDots as IconDefinition,
    fatStar as IconDefinition,
    fatStars as IconDefinition,
    fatSparkle as IconDefinition,
    fatSparkles as IconDefinition,
    fatSquare as IconDefinition,
    fatSquareV as IconDefinition,
    fatStopwatch as IconDefinition,
    /* T */
    fatTag as IconDefinition,
    fatTags as IconDefinition,
    fatTelescope as IconDefinition,
    fatThumbsUp as IconDefinition,
    fatTimer as IconDefinition,
    fatTools as IconDefinition,
    fatTrash as IconDefinition,
    fatTrophy as IconDefinition,
    fatTrophyStar as IconDefinition,
    /* U */
    fatUpDownLeftRight as IconDefinition,
    fatUserCircle as IconDefinition,
    fatUser as IconDefinition,
    fatUserMagnifyingGlass as IconDefinition,
    fatUserPlus as IconDefinition,
    fatUsers as IconDefinition,
    fatUserSlash as IconDefinition,
    fatUserShield as IconDefinition,
    fatUserTag as IconDefinition,
    fatUserTie as IconDefinition,
    /* V */
    /* W */
    fatWaveformLines as IconDefinition,
    fatWandMagicSparkles as IconDefinition,
    fatWallet as IconDefinition,
    /* X */
    fatX as IconDefinition,
    fatXmarkLarge as IconDefinition,
    fatXmarkToSlot as IconDefinition,
    fatXmark as IconDefinition
    /* Y */
    /* Z */
  );

  /* BRAND */
  library.add(
    /* A */
    /* B */
    fabBehance,
    fabBitbucket,
    fabBloggerB,
    /* C */
    /* D */
    fabDribbble,
    /* E */
    /* F */
    fabFacebookF,
    fabFigma,
    /* G */
    fabGithub,
    fabGitlab,
    fabGoogleScholar,
    /* H */
    /* I */
    fabInstagram,
    /* J */
    /* K */
    fabKaggle,
    /* L */
    fabLinkedinIn,
    /* M */
    fabMedium,
    /* N */
    fabNotion,
    /* O */
    /* P */
    /* Q */
    /* R */
    fabResearchgate,
    /* S */
    fabStackOverflow,
    /* T */
    fabTiktok,
    fabTwitter,
    /* U */
    /* V */
    fabVimeoV,
    /* W */
    /* X */
    /* Y */
    fabYoutube
    /* Z */
  );

  library.add(ALIcons as IconDefinition[]);
  app.component('FaIcon', FontAwesomeIcon);
  app.component('FontAwesomeIcon', FontAwesomeIcon);
}
